//export const environment = "fluincrdev.tmssas.com";
export const environment = "fluincr.com";

export const URL = `https://${environment}`;

export const postRestURL = `${URL}/postrest`;

export const backendURL = `${URL}/fluincrbackend/api`;

export const paypalURL = `${backendURL}/paypal/getAuthorizationUrl`;

export const URLplatform = `https://fluincr.com`;
//export const URLplatform = `https://fluincrdev.tmssas.com`;


export const fluincrCaresES = `https://support.fluincr.com/portal/es/home`;
export const fluincrCaresEN = `https://support.fluincr.com/portal/en/home`;

export const contactES = `https://support.fluincr.com/portal/es/newticket`;
export const contactEN = `https://support.fluincr.com/portal/en/newticket`;
